export const NAV_BAR_HEIGHT_REM = 4;

// Relationships
export const RELATIONSHIP_BOX_WIDTH = 192; // must be equivalent in pixels to boxWidthTailwind
export const RELATIONSHIP_BOX_WIDTH_TAILWIND = 'w-full';
export const RELATIONSHIP_BOX_HEIGHT = 52;
export const RELATIONSHIP_PADDING_RIGHT = 8;
export const RELATIONSHIP_SVG_ARROWS_WIDTH = 128;
export const RELATIONSHIP_MODAL_BODY_WIDTH = 520;
